import React, { Component } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookmark } from "@fortawesome/free-regular-svg-icons";

import {
  bookmarkRecommendation,
  removeBookmarkRecommendation
} from "../../helper/bookmark_helper";

class BookmarkRecommendation extends Component {
  state = {};

  constructor(props) {
    super(props);
    this.state = {
      bookmark: props.recommendation.bookmark
    };
  }

  componentWillUnmount() {
    if (this.recommendationBookmark) {
      this.recommendationBookmark.cancel();
    }
    if (this.recommendationRemoveBookmark) {
      this.recommendationRemoveBookmark.cancel();
    }
  }

  render() {
    var style = {};
    if (this.state.bookmark === true) {
      style = { color: "#ff5116" };
    }
    return (
      <div className="share-button ">
        <div
          className="comment_number_icon"
          style={style}
          onClick={this.handlerBookmark}
        >
          <FontAwesomeIcon icon={faBookmark} />
        </div>
      </div>
    );
  }

  handlerBookmark = e => {
    if (this.props.recommendation.can_bookmark === false) {
      //Push To Profile View
      this.props.history.push("/profile");
      return;
    }

    const self = this;
    if (this.state.bookmark === true) {
      this.recommendationBookmark = removeBookmarkRecommendation(
        this.props.recommendation.id
      );
      this.recommendationBookmark.promise.then(answer => {
        self.setState({ bookmark: false });
        if (self.props.handlerBookmarkRecommendation) {
          self.props.handlerBookmarkRecommendation(
            self.props.recommendation,
            false
          );
        }
      });
    } else {
      this.recommendationRemoveBookmark = bookmarkRecommendation(
        this.props.recommendation.id
      );
      this.recommendationRemoveBookmark.promise.then(answer => {
        self.setState({ bookmark: true });
        if (self.props.handlerBookmarkRecommendation) {
          self.props.handlerBookmarkRecommendation(
            self.props.recommendation,
            true
          );
        }
      });
    }
  };
}

export default BookmarkRecommendation;



// WEBPACK FOOTER //
// ./src/components/bookmark/bookmark_recommendation.jsx